import * as inquiryCreators from '../creators/inquiryCreators';

export let addInquiryType = (inquiryType) => {
    return {
        type: inquiryCreators.ADD_INQUIRY_TYPE,
        inquiryType
    };
};

export let addInquiryText = (text) => {
    return {
        type: inquiryCreators.ADD_INQUIRY_TEXT,
        text
    };
};

export let changeConsent = (consent) => {
    return {
        type: inquiryCreators.CHANGE_INQUIRY_CONSENT,
        consent
    };
};

export let addContactInfo = (data) => {
    return {
        type: inquiryCreators.ADD_CONTACT_INFO,
        data
    };
};

export let setTargetSystems = (targetSystems) => {
    return {
        type: inquiryCreators.SET_TARGET_SYSTEMS,
        targetSystems
    }
};

export let addRecaptchaToken = (token) => {
    return {
        type: inquiryCreators.ADD_RECAPTCHA_TOKEN,
        token
    };
};

export let changeLang = (lang) => {
    return {
        type: inquiryCreators.CHANGE_LANG,
        lang
    };
};

export const localeSet = lang => ({
    type: inquiryCreators.LOCALE_SET,
    lang
});

export const setLocale = lang => dispatch => {
    localStorage.alhubLang = lang;
    dispatch(localeSet(lang));
};

export let resetState = () => {
    return {
        type: inquiryCreators.RESET_STATE,
    };
};

export let verifiedNumberSuccess = () => {
    return {
        type: inquiryCreators.VERIFY_PHONE_NUMBER_SUCCESS
    };
};

export let verifiedNumberError = () => {
    return {
        type: inquiryCreators.VERIFY_PHONE_NUMBER_ERROR
    };
};